import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import cookies from "js-cookie";
import * as actionTypes from "../store/actions/actionTypes";

const LogOutRoute = (props) => {
  cookies.remove("token");
  window.location.href = "/dashboard/login";
  return (
    // After clearing the cookie, redirect to the login page
    <Redirect to={{ pathname: "/dashboard/login" }} />
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset: () => {
      dispatch({
        type: actionTypes.RESET_APP
      });
    }
  };
};

export default connect(null, mapDispatchToProps)(LogOutRoute);
